import React from "react";

import { DashboardCard2 } from "@/components/layout/DashboardCard2";
import ProgressBar from "@/components/UI/ProgressBar";

import { getMemberProgress } from "../../helpers/member-progress";

export function PatientProfile90DayProgress(props) {
  let { daysCompleted, endStr, remainingDays, startStr } = getMemberProgress(props.patientDetails);
  const daySuffix =
    daysCompleted % 10 === 1 && daysCompleted !== 11
      ? "st"
      : daysCompleted % 10 === 2 && daysCompleted !== 12
        ? "nd"
        : daysCompleted % 10 === 3 && daysCompleted !== 13
          ? "rd"
          : "th";

  return (
    <DashboardCard2>
      <div className="row">
        <div className="col-lg-3 col-12 PatientProfile__90DayProgressTitle">
          <b>90 Day Care Program</b>
        </div>

        <div className="col-lg-9 col-12">
          <ProgressBar
            currentMarker={daysCompleted}
            currentMarkerTitle={`${daysCompleted}${daySuffix} Day`}
            height="6px"
            now={getPercentage(remainingDays)}
          />

          <div className="d-flex justify-content-between my-2">
            <div>
              <span>
                <b>Start Date</b>
              </span>
              <br />
              <span>{startStr}</span>
            </div>
            <div style={{ textAlign: "right" }}>
              <span>
                <b>End Date</b>
              </span>
              <br />
              <span>{endStr}</span>
            </div>
          </div>
        </div>
      </div>
    </DashboardCard2>
  );
}

const getPercentage = (remainingTime) => {
  let percentagetext;

  if (remainingTime != null) {
    let passedTime = 90 - remainingTime;

    percentagetext = Math.floor((100 / 90) * passedTime);
  }

  return percentagetext;
};
